import {Component} from '@angular/core';

@Component({
    selector: 'app-red-flag-shut-down-banner',
    styleUrls: ['./red-flag-shut-down-banner.sass'],
    templateUrl: 'red-flag-shut-down-banner.tpl.html'
})

export class RedFlagShutDownBannerComponent {}
